export const environment = {
  production: true,
  envName: 'dev',
  serverURL: "https://dev.spaceforthoughts.com:8080"
};
